import { RememberMeOutlined } from "@mui/icons-material";

const associationResource = {
    title: "Associations and Organizations",
    singular: "Association",

    collectionField: "associations",

    displayField: "name",

    icon: RememberMeOutlined,

    columns: [
        {
            field: "name",
            header: "Name",
            type: "text"
        }
    ],

    fields: {
        name: {
            name: "name",
            label: "Name",
            type: "text",
            required: true
        }
    }
};

export default associationResource;
